const HEADER_MOD = {
  "How does your analytics sync with your source HCM system?": {
    header: "Automated HR Processes",
    negCopy: "HR teams rely on up-to-date information to make fast decisions.",
    negLink:["https://www.oracle.com/a/ocom/docs/oracle-hcm-fusion-analytics-ebook.pdf"
  ],
    negLinkTxt: ["Oracle Fusion HCM Analytics eBook"],
  },

  "How do you correlate (what do you do to define or identify these groups) talent and compensation?":
    {
      header: "Top Talent Assessment",
      negCopy:
        "Analysis of compa-ratio bands ensures top performers are compensated appropriately.",
      negLink: [
        "https://www.oracle.com/webfolder/s/quicktours/hcm/gqt-hcm-talentmgmt/index.html",
        "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pt-ba-talentmgmt-analytics/index.html ",
      ],
      negLinkTxt: [
        "Oracle Talent Management Product Tour",
        "Talent Analytics Product Tour",
      ],
    },
  "What is your process for analyzing various dimensions of diversity?": {
    header: "D&I Analytics",
    negCopy:
      "Successful D&I efforts require analysis of more than just one or two dimensions of diversity.",
    negLink: ["https://www.oracle.com/a/ocom/docs/selecthub-driving-diversity-with-comprehensive-analytics-white-paper.pdf","https://www.oracle.com/customers/synlait/ "],
    negLinkTxt: ["NEW – “Driving diversity with comprehensive analytics” PDF","Customer Story: Synlait"],
  },
  "What is your company’s approach to cloud adoption for HR?": {
    header: "Cloud Adoption",
    negCopy:
      "Surround base HR operations with cloud-supported systems and processes.",
    negLink:
      ["https://www.oracle.com/a/ocom/docs/applications/human-capital-management/hrt-talent-analytics-hrdotcom.pdf "],
    negLinkTxt: ["The State of HR Analytics 2021"],
  },
  "How do you tie HR metrics to larger business and financial strategy?": {
    header: "Cross Departmental",
    negCopy:
      "A holistic view of HR business and financial strategy is necessary to align workforce investment.",
    negLink: [
      "https://blogs.oracle.com/analytics/post/connecting-supply-chain-and-workforce-insight-to-improve-operational-execution-and-flexibility",
      "https://www.oracle.com/business-analytics/fusion-hcm-analytics/?ytid=NRdVRMQMigY",
    ],
    negLinkTxt: [
      "Connecting Supply Chain and Workforce Insight to Improve Operational Execution",
      "Oracle Fusion HCM Analytics",
    ],
  },
  "How do you monitor team effectiveness, retention, & more?": {
    header: "Team Effectiveness",
    negCopy:
      "Assessing team effectiveness goes beyond just individual performance.",
    negLink:
      ["https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html"],
    negLinkTxt: ["Workforce Analytics Product Tour"],
  },
  "Which best describes how you analyze workforce retention and measure joiners & leavers?":
    {
      header: "Attrition and Retention",
      negCopy:
        "It’s not enough to examine historical attrition data – predict future rates with embedded machine learning.",
      negLink:
        ["https://www.oracle.com/explore/hcm-analytics/interactive-hr-attrition/?lb-mode=overlay&source=:ow:o:h:mt:::RC_WWMK210916P00034:NA22_HCM_OC_CO55_M0601_SO005YO01_DO0792_AO01_RO001&intcmp"],
      negLinkTxt: ["Oracle Analytics Product Demo"],
    },
  "Which best describes how you leverage predictive analytics for HR today?": {
    header: "Predictive Analytics",
    negCopy:
      "Predictive Analytics is becoming a differentiator for HR Analytics customers.",
    negLink: ["https://www.oracle.com/a/ocom/docs/analytics-workday-compete.pdf"],
    negLinkTxt: ["Is Your Organization Using the Power of Your People Data?"],
  },
  "How do you forecast labor availability?": {
    header: "Forecasting Labor Availability",
    negCopy:
      "HR Analytics customers need more than just past trend analysis to ensure they are ahead of the competition.",
    negLink:
      ["https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html"],
    negLinkTxt: ["Workforce Analytics Product Tour"],
  },
  "How would you describe your HR data preparation process?": {
    header: "Data Preparation",
    negCopy:
      "Reducing your reliance on data scientists for everyday analytical processes allows for faster decision-making.",
    negLink:
      ["https://www.oracle.com/a/ocom/docs/ventana-research-packaged-analytics-oracle-white-paper.pdf"],
    negLinkTxt:
      ["Empowering Line-of-Business Employees with Packaged Analytics Applications"],
  },

  "How do you enrich your HCM data with external data?": {
    header: "External Data",
    negCopy:
      "Extension of your HR analysis promotes more accurate benchmarking.",
    negLink: [
      "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html",
      "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-analyticsforHR/index.html",
    ],
    negLinkTxt: [
      "Enrich with other sources in HCM Product Tour",
      "Agile HR Analytics Product Tour",
    ],
  },
  "How do you measure the efficiency of your candidate pipeline?": {
    header: "Recruiting Effectiveness",
    negCopy:
      "Identifying your most lucrative talent pools can increase hiring effectiveness and streamline the recruiting process.",
    negLink: [
      "https://www.oracle.com/a/ocom/docs/fusion-analytics-warehouse-infographic.pdf",
      "https://www.oracle.com/webfolder/s/quicktours/hcm/pt-hcm-recruiting/index.html?source=:ad:pas:go:eng:a_nas:71700000088380858-58700007477483604-p67203261328:RC_WWMK181223P00012C0001:MainAd",
    ],
    negLinkTxt: [
      "Oracle Fusion Analytics Infographic",
      "Oracle Recruiting Product Tour",
    ],
  },

  "How do you evaluate compensation trends?": {
    header: "Compensation Trends",
    negCopy:
      "Take your compa-ratio analysis to the next level with accurate projections and future forecasting.",
    negLink:
      ["https://blogs.oracle.com/analytics/post/hr-analytics-plays-a-vital-role-in-the-evolving-workplace"],
    negLinkTxt: ["HR Analytics plays a vital role in the evolving workplace" ] ,
  },
  "How do you track employee career mobility?": {
    header: "Career Mobility",
    negCopy: "Create more opportunities to advance within the organization.",
    negLink:
      ["https://blogs.oracle.com/analytics/post/how-to-build-a-people-analytics-foundation-to-create-a-healthy-high-performing-company-that-scales"],
    negLinkTxt:
      ["How to Build a People Analytics Foundation to Create a Healthy, High-performing Company that Scales"],
  },
  "How do you currently assess performance and goals (make more time for me to get to know my employees and give more productive feedback)?":
    {
      header: "Performance and Goals",
      negCopy:
        "Make recommendations automatically based on performance scores vs. goals entered.",
      negLink: [
        "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html",
        "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pt-ba-talentmgmt-analytics/index.html",
      ],
      negLinkTxt: [
        "Workforce Analytics Product Tour",
        "Talent Analytics Product Tour",
      ],
    },
  "How do you incorporate survey data to enrich HR processes?": {
    header: "Survey Analytics",
    negCopy:
      "Assessing sentiment analysis results with codes for termination provides insights for improvement.",
    negLink: [
      "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pt-ba-talentmgmt-analytics/index.html",
      "https://www.oracle.com/business-analytics/fusion-hcm-analytics/",
      "https://www.oracle.com/human-capital-management/",
    ],
    negLinkTxt: [
      "Workforce Analytics Product Tour",
      "Oracle Fusion HCM Analytics",
      "Oracle Human Capital Management (HCM)",
    ],
  },
  "How do you report on employee skill development?": {
    header: "Skills Analysis",
    negCopy:
      "Understand the overall skills matrix at your organization and take a more active approach to developing roles and career paths.",
    negLink: [
      "https://www.oracle.com/a/ocom/docs/cloud-essentials-empower-business-hcm.pdf",
      "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pt-ba-talentmgmt-analytics/index.html",
    ],
    negLinkTxt: [
      "Workforce Analytics Product Tour",
      "Talent Analytics Product Tour",
    ],
  },
};
export default HEADER_MOD;
